import * as $ from "jquery";

export default {
    getFields(Selector) {
        return {
            "cart[agree_rules]"    : 'required',
        }
    }
}import * as $ from "jquery";

export default {
    getFields(Selector) {
        return {
            "cart[agree_rules]"    : 'required',
        }
    }
}